exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aboutus_container\r\n{\r\n    width: 45%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.margin_topbottom50{\r\n    margin-top: 50px;\r\n    margin-bottom: 50px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/components/about/about.component.css
// module id = ../../../../../src/app/components/about/about.component.css
// module chunks = main